const UPDATE_BOOKFOR_PERSON = 'recurrenceMaster/UPDATE_BOOKFOR_PERSON';
const UPDATE_BOOKFOR_ISLOADING = 'recurrenceMaster/UPDATE_BOOKFOR_ISLOADING';
const UPDATE_BOOKFOR_SUGGESTIONS = 'recurrenceMaster/UPDATE_BOOKFOR_SUGGESTIONS';

export default {
  UPDATE_BOOKFOR_PERSON,
  UPDATE_BOOKFOR_ISLOADING,
  UPDATE_BOOKFOR_SUGGESTIONS
};
